import * as request from '../../utils/request'

export function listChild (param) {
  return request.post('sys.org.listChild', '1.0.0.0', param)
}

export function get (param) {
  return request.post('sys.org.get', '1.0.0.0', param)
}

export function create (param) {
  return request.post('sys.org.create', '1.0.0.0', param)
}

export function update (param) {
  return request.post('sys.org.update', '1.0.0.0', param)
}

export function del (param) {
  return request.post('sys.org.delete', '1.0.0.0', param)
}
